import React from 'react'
import {CreateLinkPage} from './pages/CreateLinkPage'
import {LinkDetailPage} from './pages/LinkDetailPage'
import {AuthPageSocial} from "./pages/AuthPageSocial"
import {AuthPageForm} from './pages/AuthPageForm'
import {RegisterPageSocial} from "./pages/RegisterPageSocial"
import {RegisterPageForm} from "./pages/RegisterPageForm"
import {DeletePage} from "./elements/DeletePage"
import {ProfilePage} from "./pages/ProfilePage"
import {MainPage} from "./pages/MainPage"
import {Routes, Route, Navigate} from 'react-router-dom'
import {ExitPage} from "./elements/ExitPage"
import {NotePage} from "./pages/NotePage"
import {VerifyPage} from "./pages/VerifyPage"
import {CreateFolderPage} from "./pages/CreateFolderPage"
import {FolderPage} from "./pages/FolderPage"
import {FolderDetailPage} from "./pages/FolderDetailPage"
import {CreateNotePage} from "./pages/CreateNotePage"
import {NoteDetailPage} from "./pages/NoteDetailPage"
import {ModalWin} from "./elements/ModalWin"
import {RestorePage} from "./pages/RestorePage"
import {ChangePasswordPage} from "./pages/ChangePasswordPage"
import {LoaderClass} from "./elements/LoaderClass"
import {UploadSingleImageFilePage} from "./pages/UploadSingleImageFilePage"
import {UploadAvatar} from "./elements/UploadAvatar"
import {UploadAvatarToPage} from "./elements/UploadAvatarToPage"
import {SaveNote} from "./elements/SaveNote"
import {SaveNewNote} from "./elements/SaveNewNote"
import {MainMoneyPage} from "./pages/MainMoneyPage"
import {MonthDetailPage} from "./pages/MonthDetailPage"
import {YearDetailPage} from "./pages/YearDetailPage"
import {YearMoneyPage} from "./pages/YearMoneyPage"
import {RemoveLine} from "./elements/RemoveLine"
import {UpdateLanguages} from "./elements/UpdateLanguages"
import {AddCardBankPage} from "./pages/AddCardBankPage"
import {MoneySettingsPage} from "./pages/MoneySettingsPage"
import {AddCashTo} from "./pages/AddCashTo"
import {HelpWindowPage} from "./pages/HelpWindowPage"
import {getLocalStorageItem, objectLang} from "./functions"
import {PolicyPage} from "./pages/PolicyPage"
import {MainPageAdminClass} from "./components/MainPageAdminClass"
import {CheckingCollectionsPage} from "./pages/CheckingCollectionsPage"
import {UpdateUserPage} from "./pages/UpdateUserPage"
import {FolderSharePage} from "./pages/FolderSharePage"
import {NoteSharePage} from "./pages/NoteSharePage"
import {UpdateCardBankPage} from "./pages/UpdateCardBankPage"
import {NetPhonePage} from "./pages/NetPhonePage";
import {GoogleDrivePage} from "./pages/GoogleDrivePage"
import {GoogleDriveViewFileClass} from "./components/GoogleDriveViewFileClass"
import {SortWindowPage} from "./pages/SortWindowPage"
import {ViewWindowSearch} from "./elements/ViewWindowSearch"
import {GoogleDrivePropertiesPage} from "./pages/GoogleDrivePropertiesPage"
import {GoogleDriveRenamePage} from "./pages/GoogleDriveRenamePage"
import {GoogleDriveRemovePage} from "./pages/GoogleDriveRemovePage"
import {FolderRenamePage} from "./pages/FolderRenamePage"
import {NoteRenamePage} from "./pages/NoteRenamePage"
import {LinkRenamePage} from "./pages/LinkRenamePage"
import {SaveLink} from "./elements/SaveLink"
import {SaveFolder} from "./elements/SaveFolder"
import {GoogleDriveUploadFilePage} from "./pages/GoogleDriveUploadFilePage"
import {CloudinaryUploadImagePage} from "./pages/CloudinaryUploadImagePage"
import ImageSlider from "./elements/ImageSlider"
import {GooglePhotoPage} from "./pages/GooglePhotoPage"

export const useRoutes = isAuthenticated => {
    let l = 'en'
    if (objectLang().language && objectLang().language.lang) {
        l = objectLang().language.lang
    }
    if (isAuthenticated) {
        return (
            <Routes future={{v7_relativeSplatPath: true}}>
                <Route exact path={`/${l}/admin`} element={<MainPageAdminClass/>}/>
                <Route exact path={`/${l}/policy`} element={<PolicyPage/>}/>
                <Route exact path={`/${l}/`} element={<MainPage/>}/>
                <Route exact path={`/`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/main`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/loading`} element={<LoaderClass position={'fixed'} top={120} left={'calc(50% - 24px)'} />}/>
                <Route exact path={`/${l}/modal`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/my-links`} element={<FolderPage/>}/>
                <Route exact path={`/${l}/folder/open/undefined`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/folder/open/root`} element={<Navigate to={`/${l}/my-links`} replace/>}/>
                <Route exact path={`/${l}/folder/open/:id`} element={<FolderPage/>}/>
                <Route exact path={`/${l}/folder/open-public/:id`} element={<FolderPage isPublic={true}/>}/>
                <Route exact path={`/${l}/folder/open-share/:code`} element={<FolderSharePage/>}/>
                <Route exact path={`/${l}/folder/rename/:id`} element={<FolderRenamePage/>}/>
                <Route exact path={`/${l}/note`} element={<NotePage/>}/>
                <Route exact path={`/${l}/create-link`} element={<CreateLinkPage/>}/>
                <Route exact path={`/${l}/create-folder`} element={<CreateFolderPage/>}/>
                <Route exact path={`/${l}/create-note`} element={<CreateNotePage/>}/>
                <Route exact path={`/${l}/note/open/:id`} element={<NotePage/>}/>
                <Route exact path={`/${l}/note/open-share/:code`} element={<NoteSharePage/>}/>
                <Route exact path={`/${l}/exit`} element={<ExitPage/>}/>
                <Route exact path={`/${l}/link/detail/:id`} element={<LinkDetailPage/>}/>
                <Route exact path={`/${l}/folder/detail/:id`} element={<FolderDetailPage/>}/>
                <Route exact path={`/${l}/link/rename/:id`} element={<LinkRenamePage/>}/>
                <Route exact path={`/${l}/note/detail/:id`} element={<NoteDetailPage/>}/>
                <Route exact path={`/${l}/link/remove/:id`} element={<DeletePage string={'link'}/>}/>
                <Route exact path={`/${l}/folder/remove/:id`} element={<DeletePage string={'folder'}/>}/>
                <Route exact path={`/${l}/note/rename/:id`} element={<NoteRenamePage/>}/>
                <Route exact path={`/${l}/note/remove/:id`} element={<DeletePage string={'note'}/>}/>
                <Route exact path={`/${l}/folder/save/:id`} element={<SaveFolder folder={getLocalStorageItem('folder-properties-data')}/>}/>
                <Route exact path={`/${l}/link/save/:id`} element={<SaveLink link={getLocalStorageItem('link-properties-data')}/>}/>
                <Route exact path={`/${l}/link/image-slide/:id`} element={<ImageSlider images={getLocalStorageItem('images-to-slider')}/>}/>
                <Route exact path={`/${l}/note/save/:id`} element={<SaveNote note={getLocalStorageItem('note-new')}/>}/>
                <Route exact path={`/${l}/note/save/new`} element={<SaveNewNote note={getLocalStorageItem('note-new-create')}/>}/>
                <Route exact path={`/${l}/profile`} element={<ProfilePage/>}/>
                <Route exact path={`/${l}/admin/profile`} element={<ProfilePage/>}/>
                <Route exact path={`/${l}/auth`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/auth-form`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/auth-social`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/register`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/register-form`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/register-social`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/upload-image-file`} element={<CloudinaryUploadImagePage/>}/>
                <Route exact path={`/${l}/upload-avatar-image`} element={<UploadSingleImageFilePage isAvatar={true}/>}/>
                <Route exact path={`/${l}/upload-avatar-file`} element={<UploadAvatarToPage/>}/>
                <Route exact path={`/${l}/upload-avatar`} element={<UploadAvatar/>}/>
                <Route exact path={`/${l}/money/main`} element={<MainMoneyPage/>}/>
                <Route exact path={`/${l}/money`} element={<Navigate to={`/${l}/money/main`} replace/>}/>
                <Route exact path={`/${l}/money/year`} element={<YearMoneyPage/>}/>
                <Route exact path={`/${l}/money/add-card`} element={<AddCardBankPage/>}/>
                <Route exact path={`/${l}/money/card/update`} element={<UpdateCardBankPage/>}/>
                <Route exact path={`/${l}/money/card/remove/:id`} element={<DeletePage string={'money/settings/card'}/>}/>
                <Route exact path={`/${l}/money/settings`} element={<MoneySettingsPage/>}/>
                <Route exact path={`/${l}/money/year/detail`} element={<YearDetailPage/>}/>
                <Route exact path={`/${l}/money/month/detail`} element={<MonthDetailPage/>}/>
                <Route exact path={`/${l}/money/month/remove-line`} element={<RemoveLine/>}/>
                <Route exact path={`/${l}/money/add-income`} element={<AddCashTo purpose={'income'}/>}/>
                <Route exact path={`/${l}/money/add-expense`} element={<AddCashTo purpose={'expense'}/>}/>
                <Route exact path={`/${l}/help`} element={<HelpWindowPage/>}/>
                <Route exact path={`/${l}/admin/check-collections`} element={<CheckingCollectionsPage/>}/>
                <Route exact path={`/${l}/admin/update-user`} element={<UpdateUserPage/>}/>
                <Route exact path={`/${l}/admin/update-lang`} element={<UpdateLanguages/>}/>
                <Route exact path={`/${l}/net-phone`} element={<NetPhonePage/>}/>
                <Route exact path={`/${l}/google-drive/open/:id`} element={<GoogleDrivePage/>}/>
                <Route exact path={`/${l}/google-drive/open/google-photo`} element={<GooglePhotoPage/>}/>
                <Route exact path={`/${l}/google-drive/detail/:fileId`} element={<GoogleDrivePropertiesPage/>}/>
                <Route exact path={`/${l}/google-drive/rename/:fileId`} element={<GoogleDriveRenamePage/>}/>
                <Route exact path={`/${l}/google-folder/remove/:fileId`} element={<GoogleDriveRemovePage/>}/>
                <Route exact path={`/${l}/google-file/remove/:fileId`} element={<GoogleDriveRemovePage/>}/>
                <Route exact path={`/${l}/google-drive-view/from`} element={<GoogleDriveViewFileClass/>}/>
                <Route exact path={`/${l}/google-drive/upload-file`} element={<GoogleDriveUploadFilePage/>}/>
                <Route exact path={`/${l}/sorting-elements/:id`} element={<SortWindowPage/>}/>
                <Route exact path={`/${l}/add-to-favorites`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/search`} element={<ViewWindowSearch lang={getLocalStorageItem('language') || {}}/>}/>
            </Routes>
        )
    } else {
        return (
            <Routes future={{v7_relativeSplatPath: true}}>
                <Route exact path={`/${l}/admin`} element={<MainPage/>}/>
                <Route exact path={`/en/policy`} element={<PolicyPage language={'en'}/>}/>
                <Route exact path={`/${l}/policy`} element={<PolicyPage/>}/>
                <Route exact path={`/${l}/`} element={<MainPage/>}/>
                <Route exact path={`/`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/main`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/loading`} element={<LoaderClass position={'fixed'} top={120} left={'calc(50% - 24px)'} />}/>
                <Route exact path={`/${l}/verify`} element={<VerifyPage/>}/>
                <Route exact path={`/${l}/auth-form`} element={<AuthPageForm/>}/>
                <Route exact path={`/${l}/auth-social`} element={<AuthPageSocial/>}/>
                <Route exact path={`/${l}/restore`} element={<RestorePage/>}/>
                <Route exact path={`/${l}/change-password`} element={<ChangePasswordPage/>}/>
                <Route exact path={`/${l}/register-form`} element={<RegisterPageForm/>}/>
                <Route exact path={`/${l}/register-social`} element={<RegisterPageSocial/>}/>
                <Route exact path={`/${l}/note/open/:id`} element={<NotePage/>}/>
                <Route exact path={`/${l}/note/open-share/:code`} element={<NoteSharePage/>}/>
                <Route exact path={`/${l}/note/detail/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/note/remove/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/profile`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/create-link`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/links`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/link/image-slide/:id`} element={<ImageSlider images={getLocalStorageItem('images-to-slider')}/>}/>
                <Route exact path={`/${l}/folders`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/my-links`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/notes`} element={<Navigate to={`/${l}/`} replace/>}/>
                <Route exact path={`/${l}/link/detail/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/link/remove/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/exit`} element={<MainPage/>}/>
                <Route exact path={`/${l}/folder/open/:id`} element={<FolderPage isPublic={true}/>}/>
                <Route exact path={`/${l}/folder/open/root`} element={<Navigate to={`/${l}/folder/open-public/666a0310c1c139c28daa572b`} replace/>}/>
                <Route exact path={`/${l}/folder/open-public/:id`} element={<FolderPage isPublic={true}/>}/>
                <Route exact path={`/${l}/folder/open-share/:code`} element={<FolderSharePage/>}/>
                <Route exact path={`/${l}/folder/detail/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/folder/remove/:id`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/modal`} element={<ModalWin data={getLocalStorageItem('dataModal')}/>}/>
                <Route exact path={`/${l}/upload-image-file`} element={<UploadSingleImageFilePage/>}/>
                <Route exact path={`/${l}/note/save/:id`} element={<SaveNote note={getLocalStorageItem('note-new')}/>}/>
                <Route exact path={`/${l}/sorting-elements/:id`} element={<SortWindowPage/>}/>
                <Route exact path={`/${l}/search`} element={<ViewWindowSearch lang={getLocalStorageItem('language') || {}}/>}/>
            </Routes>
        )
    }
}
